// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSearchTeamsPlayersBody = {
  query: string;
};

export type typeSearchTeamsPlayersOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    query: string;
    teams: {
      teamId: string;
      name: string;
      abbreviation: string;
      leagueId: string;
      leagueName: string;
      logoUrl?: string | null;
      primaryColorHex?: string | null;
    }[];
    players: {
      playerId: string;
      name: string;
      position?: string | null;
      headshotUrl?: string | null;
      teamId: string;
      teamName: string;
      teamAbbreviation: string;
      leagueName: string;
    }[];
  };
};

export type typeSearchTeamsPlayersOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSearchTeamsPlayersOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSearchTeamsPlayersOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSearchTeamsPlayersBody = {
  type: "object",
  properties: { query: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["query"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSearchTeamsPlayers(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSearchTeamsPlayersBody);
  }

  return async function postSearchTeamsPlayers(
    payload: typeSearchTeamsPlayersBody,
  ): Promise<
    typeSearchTeamsPlayersOutput200 | typeSearchTeamsPlayersOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSearchTeamsPlayers" failed before calling the network. #349d8e0c6909`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#349d8e0c6909" },
        },
        data: null,
      } as typeSearchTeamsPlayersOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/search/teams-players`,
      httpMethod: "POST",
      options,
    })) as typeSearchTeamsPlayersOutput200 | typeSearchTeamsPlayersOutput400;
  };
}
